import * as React from 'react';
import { Spinner } from '@fluentui/react-components';
import loadable from '@loadable/component';
import Layout from '../layouts/LoggedOut';
import LayoutSimple from '../layouts/LoggedOutSimple';
import type { RedirectProps, RouteProps } from '.';

/* istanbul ignore file */

const Loading = <Spinner size="large" />;

export const routes: Array<RouteProps> = [
  {
    path: '/logout',
    component: loadable(() => import(/* webpackChunkName: "logout" */ '../pages/Logout'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/apply',
    component: loadable(() => import(/* webpackChunkName: "apply" */ '../pages/Apply/index'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/login',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "login" */ '../pages/Login'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/login/expert',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "login" */ '../pages/Login'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/signup',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "signup" */ '../pages/Apply'), { fallback: Loading }),
    layout: LayoutSimple,
  },
  {
    path: '/register',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "signup" */ '../pages/Apply'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/referral',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "signup" */ '../pages/Apply'), { fallback: Loading }),
    layout: LayoutSimple,
  },
  {
    path: '/join',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "signup" */ '../pages/Join'), { fallback: Loading }),
    layout: Layout,
  },
  {
    path: '/support-form',
    component: loadable(() => import(/* webpackChunkName: "support-form" */ '../pages/SupportForm/AnonSupportPage'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/deleted/:resource',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "delete" */ '../pages/Deleted')),
    layout: Layout,
  },
];

export const redirects: Array<RedirectProps> = [
  { from: '/', to: '/signup' },
  { from: '/logout', to: '/signup' },
  { from: '/apply', to: '/signup' },
];

export const NotFound = loadable(() => import(/* webpackChunkName: "404-out" */ '../pages/NotFound/LoggedOut'), {
  fallback: Loading,
});
